// VOICE ON EVERY SECTION (Booking_Pack_FINAL_2): every card/section gets its own
// 🔊 Listen (reads just that section, en-GB, tap again to stop) and, where the
// section has boxes, a 🎤 Speak (dictates into the box in use or the first empty
// one; numbers go into number boxes). Sits at the right of the section heading.
const W2N = { zero: 0, oh: 0, one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9, ten: 10, eleven: 11, twelve: 12, thirteen: 13, fourteen: 14, fifteen: 15, sixteen: 16, seventeen: 17, eighteen: 18, nineteen: 19, twenty: 20, thirty: 30, forty: 40, fifty: 50, sixty: 60, seventy: 70, eighty: 80, ninety: 90, hundred: 100 };

export function spokenNumber(text) {
  const d = String(text).replace(/,/g, '').match(/-?\d+(\.\d+)?/);
  if (d) return d[0];
  let total = 0, found = false;
  String(text).toLowerCase().split(/[\s-]+/).forEach((w) => {
    if (w in W2N) { found = true; total = W2N[w] === 100 ? (total || 1) * 100 : total + W2N[w]; }
  });
  return found ? String(total) : '';
}

const setVal = (el, v) => {
  const proto = el.tagName === 'TEXTAREA' ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
  const setter = Object.getOwnPropertyDescriptor(proto, 'value');
  try { setter.set.call(el, v); el.dispatchEvent(new Event('input', { bubbles: true })); el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) { el.value = v; }
};

export function dictateIntoBox(target, onDone) {
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR || !target) return false;
  const rec = new SR();
  rec.lang = 'en-GB'; rec.interimResults = false; rec.continuous = false;
  rec.onresult = (e) => {
    const text = Array.from(e.results).map((r) => r[0].transcript).join(' ').trim();
    const v = target.type === 'number' ? spokenNumber(text) : (target.value ? `${target.value} ` : '') + text;
    if (v !== '') setVal(target, v);
    if (onDone) onDone(true);
  };
  rec.onend = () => onDone && onDone(false);
  rec.onerror = () => onDone && onDone(false);
  try { rec.start(); return true; } catch (e) { return false; }
}

let speakingBtn = null;
function sectionListen(card, btn) {
  if (speakingBtn === btn) { window.speechSynthesis.cancel(); speakingBtn = null; btn.textContent = '🔊'; return; }
  if (speakingBtn) { speakingBtn.textContent = '🔊'; }
  window.speechSynthesis.cancel();
  const clone = card.cloneNode(true);
  clone.querySelectorAll('[data-sv]').forEach((n) => n.remove());
  let text = clone.innerText.replace(/\s+/g, ' ').trim();
  card.querySelectorAll('input, textarea').forEach((i) => { if (i.value) text += `. ${i.getAttribute('aria-label') || ''} ${i.value}`; });
  if (!text) text = 'Nothing to read in this section yet.';
  const u = new SpeechSynthesisUtterance(text.slice(0, 2500));
  u.lang = 'en-GB';
  u.onend = () => { if (speakingBtn === btn) { speakingBtn = null; btn.textContent = '🔊'; } };
  speakingBtn = btn; btn.textContent = '⏸';
  window.speechSynthesis.speak(u);
}

function sectionSpeak(card, btn) {
  const boxes = Array.from(card.querySelectorAll('input:not([type=hidden]):not([type=file]):not([disabled]), textarea:not([disabled])'));
  if (!boxes.length) return;
  const active = document.activeElement;
  const target = (boxes.includes(active) && active) || boxes.find((b) => !b.value) || boxes[0];
  btn.textContent = '●';
  const ok = dictateIntoBox(target, () => { btn.textContent = '🎤'; });
  if (!ok) btn.textContent = '🎤';
}

function makeBtn(label, title, onClick) {
  const b = document.createElement('button');
  b.type = 'button'; b.textContent = label; b.title = title;
  b.setAttribute('data-sv', '1');
  b.setAttribute('data-testid', label === '🔊' ? 'sv-listen-btn' : 'sv-speak-btn');
  b.className = 'sv-btn';
  b.addEventListener('mousedown', (e) => e.preventDefault());
  b.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); onClick(); });
  return b;
}

const DEFAULT_SEL = '.bk-card, .card';

export function enhanceSections(root, selector = DEFAULT_SEL) {
  if (!root) return;
  root.querySelectorAll(selector).forEach((card) => {
    let wrap = Array.from(card.querySelectorAll('.sv-wrap')).find((w) => w.closest(selector) === card);
    const hasBoxes = !!card.querySelector('input:not([type=hidden]):not([type=file]), textarea');
    if (card.dataset.svDone && wrap) {
      if (hasBoxes && !wrap.querySelector('[data-testid="sv-speak-btn"]')) {
        wrap.appendChild(makeBtn('🎤', 'Speak into the box in use', () => sectionSpeak(card, wrap.lastChild)));
      }
      return;
    }
    card.dataset.svDone = '1';
    wrap = document.createElement('span');
    wrap.setAttribute('data-sv', '1');
    wrap.className = 'sv-wrap';
    wrap.appendChild(makeBtn('🔊', 'Listen to this section', () => sectionListen(card, wrap.firstChild)));
    if (hasBoxes) {
      wrap.appendChild(makeBtn('🎤', 'Speak into the box in use', () => sectionSpeak(card, wrap.lastChild)));
    }
    const heading = card.querySelector('.bk-eyebrow, .eyebrow, .luxe-eyebrow, h1, h2, h3');
    if (heading && heading.closest(selector) === card) {
      heading.appendChild(wrap);
    } else {
      wrap.classList.add('sv-inline');
      card.appendChild(wrap);
    }
  });
}

export function watchSections(container, selector = DEFAULT_SEL) {
  if (!container) return () => {};
  enhanceSections(container, selector);
  let t = null;
  const obs = new MutationObserver(() => {
    clearTimeout(t);
    t = setTimeout(() => enhanceSections(container, selector), 250);
  });
  obs.observe(container, { childList: true, subtree: true });
  return () => { obs.disconnect(); clearTimeout(t); window.speechSynthesis.cancel(); };
}
